import { createApp } from "vue";
import App from "./App.vue";
import { store } from "./store";
import * as echarts from 'echarts'
import router from "./router";
import Constants from "./constant";
import VueWechatTitle from 'vue-wechat-title';
import SvgIcon from '@/components/SvgIcon/index.vue'
import ElementPlus from "element-plus";
import "element-plus/lib/theme-chalk/index.css";
import locale from "element-plus/lib/locale/lang/zh-cn";
const app = createApp(App);
app.component('svg-icon', SvgIcon)
app.use(VueWechatTitle);
app.use(store);
app.use(router);
app.use(ElementPlus, { locale });
app.config.globalProperties.$constant = Constants;
app.mount("#app");
app.echarts=echarts


